import { Component, OnInit } from '@angular/core'
import { AuthService } from '@auth/services/auth.service'

/**
 * Handles a redirected user from a billing operation, usually after upgrading a workspace via stripe
 * OR connecting stripe
 */
@Component({
  selector: 'ngx-successful-upgrade',
  templateUrl: './successful-upgrade.component.html',
  styleUrls: ['./successful-upgrade.component.scss'],
  imports: []
})
export class SuccessfulUpgradeComponent implements OnInit {
  /**
   * Creates the component & injects it's dependencies
   * @param auth AuthService
   */
  constructor(private auth: AuthService) {}

  /**
   * Navigates immediately to the organization settings billing section
   */
  ngOnInit(): void {
    this.auth.navigateToPage('billing')
  }
}
